import { configureStore, createSlice } from "@reduxjs/toolkit";

const initProfil = {
    _id: '',
    status: 'user',

    lastName: '',
    firstName: '',

    profession: '',
    mainLocation: '',
    secondaryLocations: [],

    proPhone: '',
    secretaryPhone: '',
    proEmail: '',
    secureProEmail: '',

    patientComTool: [],
    otherPatientComTool: '',
    adminComTool: [],
    otherAdminComTool: '',
    interproTool: [],
    otherInterproTool: '',
    meetingTool: [],
    otherMeetingTool: '',

    urgentContact: [],
    otherUrgentContact: '',
    dailyContact: [],
    otherDailyContact: '',
    weeklyContact: [],
    otherWeeklyContact: '',

    targetAudiences: [],
    otherTargetAudiences: '',
    importantInfo: '',

    infoExpected: {
        physiotherapist: '',
        pharmacist: '',
        ide: '',
        others: [],
    },

    access: false,
    accessList: [],
    accessRequest: [],
}

const profilSlice = createSlice({
    name: "profil",
    initialState: initProfil,
    reducers: {
        setProfil: (state, action) => {
            const newProfil = action.payload;
            state = newProfil === null ? initProfil : newProfil;
            return state;
        }
    }
})

export const { setProfil } = profilSlice.actions;

const siteSlice = createSlice({
    name: "site",
    initialState: {
        wait: 0,
        message: ''
    },
    reducers: {
        setWait: (state, action) => {
            state.wait = state.wait + action.payload;
            state.message = state.wait === 0 ? '' : 'Chargement en cours, merci de patienter'
            return state;
        },
        setMessage: (state, action) => {
            state.message = action.payload ? action.payload : '';
            return state;
        }
    }
})

export const { setWait, setMessage } = siteSlice.actions;

// ------------------------------------------------------------------------------------------------
// ------------------------------------------------------------------------------------------------

export const store = configureStore({
    reducer: {
        profil: profilSlice.reducer,
        site: siteSlice.reducer,
    }
});